































import Vue, { PropType } from 'vue'
import { mapActions, mapState } from 'vuex'
import Logo from '@/components/atoms/Logo/Logo.vue'
import XIcon from '@/components/atoms/Icon/XIcon.vue'
import { User } from '@/types/generated/graphql'

export default Vue.extend({
  name: 'XAppBar',
  components: { Logo, XIcon },
  props: {
    user: {
      type: Object as PropType<User>,
      required: false,
    },
  },
  data() {
    return {
      open: false,
      items: [
        // {
        //   id: 'diaryrecords',
        //   title: this.$tc('diaryrecords.title'),
        //   icon: { name: 'mdi-file-edit-outline' },
        //   routeName: 'DiaryRecords',
        // },
        // {
        //   id: 'notifications',
        //   title: this.$tc('notifications.title'),
        //   icon: { name: 'mdi-email-outline' },
        //   routeName: 'Notifications',
        // },
      ],
    }
  },
  computed: {
    ...mapState('drawer', ['isOpen']),
  },
  methods: {
    ...mapActions('auth', ['logout']),
    ...mapActions('drawer', ['toggleDrawer']),
    signout() {
      this.logout().then(() => {
        this.$router.push({ name: 'Login' })
      })
    },
  },
})
